BinderLiveSingleSport = window.BinderLiveSingleSport = (function () {
    const selectors = {
        tbTable: '.events-table',
        tbEvent: '.events-table__body-row',

        tbFavstar: '[tb-favstar]',
        tbCalendar: '[tb-calendar]',
        searchFavstar: '[search-favstar]',
        searchEvent: '[search-event]',


        vmSelectAll: '#sports-filter__select-all',
        vmSportsFilterItem: '.sports-filter__item',
        vmSportsFilterSelectButton: '.j-sports-filter-item-select-button',
        vmSportsFilterLinkButton: '.j-sports-filter-item-link-button',
        vmSportsFilterItemsContainer: '#vm-sports-filter-items',

        emptyBetplace: '#live-empty_betplace',
        cmSorting: '#cm-sorting',

        broadcastFilter: '#tv-broadcast-filter',
        visualizationFilter: '#visualization-filter',

        pageScrollbarContainer: '#m-page-content-scrollbar-scrollarea'
    };

    const vmSelectedClass = 'm-selected';
    var sportType;

    var bindUI = function (isFavorite) {
        var body = app.body;
        if (isFavorite === undefined) {
            isFavorite = false;
        }

        // toggle SportFilterItem v3.0
        $(document).on('click', selectors.vmSportsFilterItem + '[data-sport-type-id]', function (e) {
            e.stopImmediatePropagation();
            e.preventDefault();

            var container = $(this),
                sportId = container.data('sport-type-id');

            var isAllChecked = $(selectors.vmSportsFilterItemsContainer).find(selectors.vmSportsFilterItem + ':not(.m-selected)').length > 0 ? false : true;

            if (isAllChecked) {
                container.addClass('m-loading');
                Ajax.postJson("/Live/EnableOnlyOneItem", {
                    data: {
                        sportId: sportId
                    },
                    doCallAjaxViewParsers: false,
                    success: function (resp) {
                        $(selectors.vmSelectAll).prop('checked', false);
                        app.ModeTableLive.clear();
                        $(selectors.vmSportsFilterItemsContainer).find(selectors.vmSportsFilterItem).removeClass('m-selected');
                        container.addClass('m-selected');

                        app.ModeTableLive.insertTable(resp.html);

                        container.removeClass('m-loading');
                    }
                });
            } else {
                toggleSportsFilterItem(sportId, container);
            }

            return false;
        });

        // toggle SportFilter v3.0
        body.on('click', selectors.vmSelectAll, function () {
            TableFetcherLive.stop();

            var that = $(this),
                removingAll = !that.prop('checked'),
                allItems = $(selectors.vmSportsFilterItemsContainer).find(selectors.vmSportsFilterItem);


            that.parent().parent().addClass('m-loading');
            Ajax.postJson("/Live/ToggleSportFilter", {
                doCallAjaxViewParsers: false,
                success: function () {
                    if (removingAll) {
                        app.ModeTableLive.clear();
                        that.prop('checked', false);
                        allItems.removeClass(vmSelectedClass);
                    }
                    else {
                        app.ModeTableLive.update();
                        that.prop('checked', true);
                        allItems.addClass(vmSelectedClass);
                    }
                    (app.ModeTableLive.count() === 0)
                        ? $(selectors.emptyBetplace).addClass('active')
                        : $(selectors.emptyBetplace).removeClass('active');

                    that.parent().parent().removeClass('m-loading');
                }
            });
            return false;
        });

        body.on('change', selectors.cmSorting, function () {
            Ajax.postJson("/Live/SetSortingType", {
                data: { sortingType: $(this).val(), sportType: sportType },
                doCallAjaxViewParsers: false,
                success: function () {
                    app.ModeTableLive.update();
                    (app.ModeTableLive.count() === 0) ? $(selectors.emptyBetplace).addClass('active') : $(selectors.emptyBetplace).removeClass('active');
                }
            });
            return false;
        });

        // <input[checkbox]> on 'live' page for Broadcast and Visualization filters
        body.on('change', selectors.broadcastFilter, function () {
            Ajax.postJson("/Live/SetBroadcastFilter", {
                data: { isBroadcastFilter: $(this).is(":checked"), isFavorite: false, sportType: sportType },
                doCallAjaxViewParsers: false,
                success: function () {
                    app.ModeTableLive.update();
                    (app.ModeTableLive.isEmpty()) ? $(selectors.emptyBetplace).addClass('active') : $(selectors.emptyBetplace).removeClass('active');
                }
            });
            return false;
        });
        body.on('change', selectors.visualizationFilter, function () {
            Ajax.postJson("/Live/SetVisualizationFilter", {
                data: { isVisualizationFilter: $(this).is(":checked"), isFavorite: false, sportType: sportType },
                doCallAjaxViewParsers: false,
                success: function () {
                    app.ModeTableLive.update();
                    (app.ModeTableLive.isEmpty()) ? $(selectors.emptyBetplace).addClass('active') : $(selectors.emptyBetplace).removeClass('active');
                }
            });
            return false;
        });

        // Fave/Unfave calendarEvent
        body.on('click', (selectors.tbCalendar), function (e) {

            var that = $(this),
                eventId = that.closest(selectors.tbEvent).data('id'),
                dataIdFilter = '[data-id=' + eventId + ']',
                isRemovingFromFav = that.hasClass('m-active');

            that.addClass('m-loading');
            Ajax.postJson(isRemovingFromFav ? "/Calendar/UnFaveEvent" : "/Calendar/FaveEvent", {
                data: {
                    id: eventId
                },
                doCallAjaxViewParsers: false,
                success: function (resp) {
                    that.toggleClass('m-active');

                    if (resp && resp.Message) {
                        that.removeClass('m-active');
                        Tooltip.errorNode(that, resp.Message);
                        that.removeClass('m-loading');
                        return;
                    }
                    if (isRemovingFromFav) {
                        var currentEvent = $(selectors.tbEvent + dataIdFilter),
                            parentTable = currentEvent.closest(selectors.tbTable);
                        if (parentTable.find(selectors.tbEvent).length <= 1) {
                            ModeTableLive.removeTable(parentTable.data('sportid'));
                            (app.ModeTableLive.count() === 0) ? $(selectors.emptyBetplace).addClass('active') : $(selectors.emptyBetplace).removeClass('active');
                        }
                        currentEvent.remove();
                    }

                    that.removeClass('m-loading');
                }
            });

            return false;
        });

        // Fave event v3.0
        body.on('click', (selectors.tbFavstar + ',' + selectors.searchFavstar), function (e) {

            var that = $(this),
                isRemovingFromFav = that.hasClass('m-active'),
                eventId = (that.is(selectors.tbFavstar)) ? that.closest(selectors.tbEvent).data('id') : that.closest(selectors.searchEvent).data('id'),
                dataIdFilter = '[data-id=' + eventId + ']',
                allStars = $.merge($(selectors.tbEvent + dataIdFilter).find(selectors.tbFavstar), $(selectors.searchEvent + dataIdFilter).find(selectors.searchFavstar));

            that.addClass('m-loading');
            Ajax.postJson(isRemovingFromFav ? "/Live/UnFaveEvent" : "/Live/FaveEvent", {
                data: {
                    id: eventId
                },
                doCallAjaxViewParsers: false,
                success: function (resp) {
                    if (resp && resp.Message) {
                        that.removeClass('m-active');
                        Tooltip.errorNode(that, resp.Message);
                        that.removeClass('m-loading');
                        return;
                    }

                    if (isRemovingFromFav) {
                        allStars.removeClass('m-active');
                        allStars.attr('bb-tool', window.Localization.getString('Scripts_Shared_Main.Accent_10', 'Добавить в избранное'));
                        if (isFavorite) {
                            var currentEvent = $(selectors.tbEvent + dataIdFilter),
                                parentTable = currentEvent.closest(selectors.tbTable);

                            if (parentTable.find(selectors.tbEvent).length <= 1) {
                                ModeTableLive.removeTable(parentTable.data('sportid'));
                                (app.ModeTableLive.count() === 0) ? $(selectors.emptyBetplace).addClass('active') : $(selectors.emptyBetplace).removeClass('active');
                            }
                            else {
                                currentEvent.remove();
                            }
                        }
                    }
                    else {
                        allStars.addClass('m-active');
                        allStars.attr('bb-tool', window.Localization.getString('Scripts_Shared_Main.Accent_11', 'Удалить из избранного'));
                        if (isFavorite && that.is(selectors.searchFavstar)) {
                            TableFetcherLive.full();
                            //TODO: Здесь получать только betPlace() без вертикального меню. и возможно не использовать fetcher (лишние расчеты diff)
                            $(selectors.emptyBetplace).removeClass('active')
                        }
                    }

                    app.VerticalMenu.changeFavorites();

                    that.removeClass('m-loading');
                },
            });

            return false;
        });


        ConfirmButton.init(
            '#live_favs-remove_all',
            function () { },
            '/Live/UnFaveAll',
            function (resp) {
                app.ModeTableLive.destroyTables();
                (app.ModeTableLive.count() === 0) ? $(selectors.emptyBetplace).addClass('active') : $(selectors.emptyBetplace).removeClass('active');
                app.VerticalMenu.changeFavorites();
            }
        );

    };

    var unBindUI = function () {
        app.body
            .off('click', (selectors.tbFavstar + ',' + selectors.searchFavstar))
            .off('click', selectors.tbCalendar)
            .off('click', selectors.vmSelectAll)
            .off('change', selectors.cmSorting);

        $(document).off('click', selectors.vmSportsFilterItem + '[data-sport-type-id]');
        ConfirmButton.dispose('#live_favs-remove_all');
    };

    var toggleSportsFilterItem = function (sportId, sportsFilterItemContainer, callback) {
        TableFetcherLive.stop();

        var removing = sportsFilterItemContainer.hasClass(vmSelectedClass),
            allItems = $(selectors.vmSportsFilterItemsContainer).find(selectors.vmSportsFilterItem),
            selectAllbtn = $(selectors.vmSelectAll);

        sportsFilterItemContainer.addClass('m-loading');
        Ajax.postJson("/Live/ToggleSportFilterItem", {
            data: {
                sportId: sportId,
            },
            doCallAjaxViewParsers: false,
            success: function (resp) {
                if (removing) {
                    app.ModeTableLive.removeTable(sportId);
                    sportsFilterItemContainer.removeClass(vmSelectedClass);
                }
                else {
                    var prevFilter = sportsFilterItemContainer.prevAll('.' + vmSelectedClass);
                    var insertAfterId = (prevFilter.length !== 0) ? prevFilter.data('sport-type-id') : undefined;
                    app.ModeTableLive.insertTable(resp.html, insertAfterId);
                    sportsFilterItemContainer.addClass(vmSelectedClass);
                }

                selectAllbtn.prop('checked', (allItems.filter('.' + vmSelectedClass).length === allItems.length));
                (app.ModeTableLive.count() === 0) ? $(selectors.emptyBetplace).addClass('active') : $(selectors.emptyBetplace).removeClass('active');

                sportsFilterItemContainer.removeClass('m-loading');

                if (callback) callback();
            }
        });
    };

    function setScopeData(scopeData) {
        if (scopeData != undefined && scopeData.hasOwnProperty('sport')) {
            sportType = scopeData.sport;
        }
    }

    var bind = function (justLoaded, scopeData) { setScopeData(scopeData);  bindUI(); };
    var unBind = function () { unBindUI(); };
    var bindFavorites = function (justLoaded) { bindUI(true); };
    var unBindFavorites = function () { unBindUI(); };

    return {
        bind: bind,
        bindFavorites: bindFavorites,
        unBind: unBind,
        unBindFavorites: unBindFavorites,
        name: 'BinderLiveSingleSport',
        url: '/Live/GetViewSet',
    };
}());

//-----------------------------------

ScopeLiveSingleSport = (function () {

    var sportType;

    function init() {
        app.VerticalMenu.init();
        TableFetcherLive.setMode.standartSingleSport(sportType);
        app.ModeTableLive.init();

        app.Search.init('liveSingleSport', { sportType: sportType });
    }

    function dispose() {
        app.VerticalMenu.dispose();
        app.ModeTableLive.dispose();
    }

    var start = function (justLoaded, scopeData) { sportType = scopeData.sportType; init(); };
    var stop = function () { dispose(); };

    return {
        start: start,
        stop: stop,
        name: 'ScopeLiveSingleSport',
        url: 'LIVE/SPORT',
    };
}());
